
    import './styles.scoped.css';
    export default {
  "close-button": "awsui_close-button_16w0h_cw7da_93",
  "circular-toggle": "awsui_circular-toggle_16w0h_cw7da_101",
  "circular-toggle-selected": "awsui_circular-toggle-selected_16w0h_cw7da_139"
};
  